// Frame pacing watch. A device that can't keep the scenes smooth (a phone, or a computer drawing canvases without a
// GPU) gets lighter scenes for the rest of the visit: one canvas pixel per CSS pixel instead of up to two (up to four
// times fewer pixels to paint each frame; the pixel art scales up whole, so it looks the same, small canvas text is a
// little softer), the battle ground's lighting painted into the ground, and the battle's side panel redrawn less often.

/** Frames sampled before judging. */
const WINDOW = 90;
/** Median frame time (ms) above which the scenes go light: under about 40 frames a second. */
const SLOW_MS = 25;

let lite = false;
const times: number[] = [];
const listeners: (() => void)[] = [];

/** True once this device was too slow for full-resolution canvases (for the rest of the page's life). */
export const liteMode = () => lite;

/** Backing pixels per CSS pixel for a game canvas. */
export function canvasDpr(): number {
  return lite ? 1 : Math.min(2, (typeof window !== 'undefined' && window.devicePixelRatio) || 1);
}

/** Called when the canvases go light (resize them). */
export function onLite(fn: () => void) { listeners.push(fn); }

/** A scene loop reports each drawn frame's time since the previous one (ms, capped by the caller). */
export function frameTime(dtMs: number) {
  if (lite || !(dtMs > 0)) return;
  times.push(dtMs);
  if (times.length < WINDOW) return;
  const sorted = times.slice().sort((a, b) => a - b);
  times.length = 0;
  if (sorted[sorted.length >> 1] > SLOW_MS) goLite();
}

function goLite() {
  lite = true;
  for (const fn of listeners) fn();
}
